import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {repeat} from 'lit/directives/repeat.js';
import {classMap} from 'lit/directives/class-map.js';
import {property} from 'lit/decorators/property.js';
import {msg} from '@lit/localize';

import {connect} from 'pwa-helpers';
import store from '../../../store';
import {selectPersonalisation, selectShowPersonalisation, selectSpcIsSatisfied} from '../../../selectors';

@customElement('new-specsheet')
export class NewSpecsheet extends connect(store)(LitElement) {

	@property({type: String})
	type = 'detail'; // family, basic, detail

	typeLabels= {
		family: msg('Series spec sheet'),
		basic: msg('Basic spec sheet'),
		detail: msg('Detail spec sheet')
	}

	static styles = [
		css`
			:host {
				container-type: inline-size;
			}

			@media screen {
				.page {
					width: calc(100% - 80px);
					box-sizing: border-box;
					margin: 40px;
					box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.25);
				}
			}
			@media print {
				.page {
					margin:0;
					box-shadow: none;
				}
			}
			.print {
				width: 100%;
				margin: 0;
				box-shadow: none;
			}
		`
	];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.print = this.state.status.media === 'print' || this.state.status.media === 'print2';
		this.spcIsSatisfied = selectSpcIsSatisfied(state);
		if (state.specsheet.data.specsheets && state.status?.productFamily) {
			this.kirbySpecsheets = state.specsheet.data.specsheets;
			this.family = state.status.productFamily;
			this.kirbySpecsheet = this.kirbySpecsheets.find(specsheet => specsheet.id === this.family);
		}
		this.showPersonalisation = selectShowPersonalisation(state);
	}

	render() {
		return html`
			${when(this.showPersonalisation, () => html`
				<shared-specsheet-page class="page ${classMap({print: this.print})}" headLabel="${msg('Personalisation')}">
					<personalise-form></personalise-form>
				</shared-specsheet-page>
			`)}
			<shared-specsheet-page class="page ${classMap({print: this.print})}" headLabel="${this.typeLabels[this.type]}">
				<family-overview></family-overview>
			</shared-specsheet-page>
			${when(this.kirbySpecsheet?.model_image_1 !== '' || this.kirbySpecsheet?.usps.length > 0, () => html`
				<shared-specsheet-page class="page ${classMap({print: this.print})}" headLabel="${msg('Special features')}">
					<model-overview></model-overview>
				</shared-specsheet-page>
			`)}
			${when(this.kirbySpecsheet?.family_tendertext, () => html`
				<shared-specsheet-page class="page ${classMap({print: this.print})}" headLabel="${msg('Product description')}">
					<family-tendertext></family-tendertext>
				</shared-specsheet-page>
			`)}
			${when(this.type === 'family' && this.kirbySpecsheet?.model_pages, () => html`
				${repeat(this.kirbySpecsheet?.model_pages,
					(modelPage) => html`
						<shared-specsheet-page class="page ${classMap({print: this.print})}" headLabel="${msg('Models')}" title="${modelPage.model_name}">
							<model-data-page .model="${modelPage}"></model-data-page>
						</shared-specsheet-page>
				`)}
			`)}
			${when(this.type !== 'family', () => html`
				<shared-specsheet-page class="page ${classMap({print: this.print})}" headLabel="${msg('Specifications')}">
					<shared-technical-data-page></shared-technical-data-page>
				</shared-specsheet-page>
			`)}
			${when(this.spcIsSatisfied && this.type ==='detail', () => html`
				<shared-specsheet-page class="page ${classMap({print: this.print})}" headLabel="${msg('Product description')}">
					<shared-tender-text-page></shared-tender-text-page>
				</shared-specsheet-page>
			`)}
			${when(this.spcIsSatisfied && this.type === 'detail' || this.type === 'basic', () => html`
				<shared-specsheet-page class="page ${classMap({print: this.print})}" headLabel="${msg('Lighting technology')}">
					<shared-light-engine></shared-light-engine>
				</shared-specsheet-page>
			`)}
		`;
	}
}
